/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { WizardNextStepFragment } from '../../../../common/configurable-wizards/queries/queryTyping/wizard-result-next-step';
import { gql } from '@apollo/client';
import { WizardNextStepFragmentDoc } from '../../../../common/configurable-wizards/queries/queryTyping/wizard-result-next-step';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PostUserKindStepMutationVariables = Types.Exact<{
  stepParams: Types.SubmitUserKindWizardStepParams;
}>;


export type PostUserKindStepMutation = (
  { __typename?: 'Mutation' }
  & { userKindStep: Types.Maybe<(
    { __typename?: 'NextStep' }
    & WizardNextStepFragment
  ) | (
    { __typename: 'UserKindWizardResult' }
    & Pick<Types.UserKindWizardResult, 'wizardFinished' | 'successSummary' | 'userKind'>
  )> }
);


export const PostUserKindStepDocument = gql`
    mutation PostUserKindStep($stepParams: SubmitUserKindWizardStepParams!) {
  userKindStep(submitWizardStepParams: $stepParams) {
    ...WizardNextStep
    ... on UserKindWizardResult {
      __typename
      wizardFinished
      successSummary
      userKind
    }
  }
}
    ${WizardNextStepFragmentDoc}`;
export type PostUserKindStepMutationFn = Apollo.MutationFunction<PostUserKindStepMutation, PostUserKindStepMutationVariables>;

/**
 * __usePostUserKindStepMutation__
 *
 * To run a mutation, you first call `usePostUserKindStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUserKindStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUserKindStepMutation, { data, loading, error }] = usePostUserKindStepMutation({
 *   variables: {
 *      stepParams: // value for 'stepParams'
 *   },
 * });
 */
export function usePostUserKindStepMutation(baseOptions?: Apollo.MutationHookOptions<PostUserKindStepMutation, PostUserKindStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostUserKindStepMutation, PostUserKindStepMutationVariables>(PostUserKindStepDocument, options);
      }
export type PostUserKindStepMutationHookResult = ReturnType<typeof usePostUserKindStepMutation>;
export type PostUserKindStepMutationResult = Apollo.MutationResult<PostUserKindStepMutation>;
export type PostUserKindStepMutationOptions = Apollo.BaseMutationOptions<PostUserKindStepMutation, PostUserKindStepMutationVariables>;